(function () {
  const CHECKLIST_ITEMS = [
    'Delivered Every 30-Days',
    '100% Satisfaction Guarantee',
    'Free Shipping',
  ];

  // Toggle checklist visibility based on whether its parent option is active.
  // Called by a dedicated MutationObserver watching only class attr on option nodes —
  // no event listeners added, so there is no conflict with Appstle's own handlers.
  function updateChecklistVisibility() {
    document.querySelectorAll('.appstle-custom-checklist').forEach((list) => {
      const option = list.closest('.appstle_subscription_wrapper_option');
      if (!option) return;
      list.classList.toggle('appstle-checklist-hidden', !option.classList.contains('appstle-active-option'));
    });
  }

  // Watch for appstle-active-option class changes on the option wrappers.
  // Uses a targeted observer (not body-level attribute watching) to stay lightweight.
  let attrObserver = null;
  function setupAttrObserver() {
    if (attrObserver) attrObserver.disconnect();
    const options = document.querySelectorAll('.appstle_subscription_wrapper_option');
    if (!options.length) return;
    attrObserver = new MutationObserver(updateChecklistVisibility);
    options.forEach((option) => {
      attrObserver.observe(option, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function injectChecklist() {
    let injected = false;

    document.querySelectorAll('.appstle_subscription_wrapper_option').forEach((option) => {
      if (!option.querySelector('.appstle_subscribe_save_text')) return;
      if (option.querySelector('.appstle-custom-checklist')) return;

      const list = document.createElement('ul');
      list.className = 'appstle-custom-checklist';

      CHECKLIST_ITEMS.forEach((text) => {
        const li = document.createElement('li');
        li.textContent = text;
        list.appendChild(li);
      });

      const radioWrapper = option.querySelector('.appstle_subscription_radio_wrapper');
      if (radioWrapper) {
        radioWrapper.insertAdjacentElement('afterend', list);
      } else {
        option.appendChild(list);
      }

      injected = true;
    });

    if (injected) {
      setupAttrObserver();
      updateChecklistVisibility();
    }
  }

  function init() {
    injectChecklist();

    // Watch for Appstle re-renders (variant switches, lazy load, etc.)
    const domObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes.length) {
          injectChecklist();
          break;
        }
      }
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
